export default __webpack_public_path__ + "static/media/FIAGRO.b23f64c7.svg";